// extracted by mini-css-extract-plugin
export var equalColumn = "_jg-0";